import { useEffect, useRef, useState } from "react";
import { technobabbleGenerator } from "../util/technobabble";

export function useTechnobabble(rateMS: number) {
  const generator = useRef(technobabbleGenerator());
  const [tb, setTb] = useState("");
  useEffect(() => {
    const interval = setInterval(() => {
      const technobabble = generator.current();
      setTb(technobabble);
    }, rateMS);
    return () => {
      clearInterval(interval);
    };
  }, [rateMS]);

  return tb;
}
